exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tabtrap-sentinel-2VixhnpMmwr{display:block;height:0;width:0}\n", ""]);
// Exports
exports.locals = {
	"sentinel": "tabtrap-sentinel-2VixhnpMmwr"
};